import { mapState, mapActions } from 'vuex'

export default {
  name: 'TTableCampaign',
  components: {
    TFileEmpty: () => import('@/components/file-empty')
  },
  data () {
    return {
      thead: [
        { label: 'Status', name: 'status' },
        { label: 'Nome da campanha', name: 'name' },
        { label: 'Cadastrados', name: 'register' },
        { label: 'Registrados', name: 'registered' },
        { label: 'Pagos', name: 'paid' }
      ],
      totalPages: "0",
      currentPage: 1,
      pagesSelected: "0",
      total: 0,
      limit: 10,
      disabledPrev: false,
      disabledNext: false,
      titleEmpty: 'Não encontramos nenhuma campanha',
      content: 'É novo aqui? Crie uma campanha no botão, nova campanha.',
      titleButton: 'Nova campanha',
      empty: false,
      currentSort: 'created_at',
      currentSortDir: 'desc'
    }
  },
  props: {
    files: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapState({
      loading: ({ campaign }) => campaign.loading,
      listCampaigns: ({ campaign }) => campaign.listCampaigns,
      metaDataCampaigns: ({ campaign }) => campaign.metaDataCampaigns
    })
  },

  methods: {
    ...mapActions('campaign', ['getCampaigns', 'getIdCampaign']),

    sort (item) {
      this.currentSortDir = this.currentSortDir === 'desc' ? 'asc' : 'desc';
      this.currentSort = item;

      this.getCampaigns(
        {
          page: this.metaDataCampaigns.currentPage,
          limit: this.limit,
          orderBy: this.currentSort,
          order: this.currentSortDir
        }
      )
    },

    statusClass (item, key) {
      if (item === 'Iniciada') {
        return 'color-success'
      } else if  (item === 'Finalizada') {
        return 'color-registred'
      } else if  (item === 'Rascunho') {
        return 'color-warning'
      }
    },

    campaignId (id) {
      this.$router.push(`campaign/${id}`)
    },

    actionButton () {
      this.$router.push(`campaign/new`)
    },

    disabledPrevButton () {
      this.metaDataCampaigns.currentPage === 1 ? this.disabledPrev = true : this.disabledPrev = false
    },

    disabledNextButton () {
      this.metaDataCampaigns.currentPage === this.metaDataCampaigns.totalPages ? this.disabledNext = true : this.disabledNext = false
    },

    prevPage () {
      if (this.currentPage === 1) return
      this.disabledPrevButton()
      this.disabledNextButton()

      this.getCampaigns(
        {
          ...this.filter,
          page: Number(this.currentPage) - 1,
          limit: this.limit
        }
      )
    },

    nextPage () {
      if (this.currentPage === this.totalPages) return
      this.disabledPrevButton()
      this.disabledNextButton()
      this.getCampaigns(
        {
          ...this.filter,
          page: Number(this.currentPage) + 1,
          limit: this.limit
        }
      )
    },

    goToPage (page) {
      if (Number(page) < 0 || Number(page) > Number(this.totalPages)) return
      this.disabledPrevButton()
      this.disabledNextButton()
      this.currentPage = page
      this.getCampaigns(
        {
          ...this.filter,
          page: Number(page),
          limit: this.limit
        }
      )
    },

    updateMetaDataTable () {
      if ( this.metaDataCampaigns ) {
        this.totalPages = `${this.metaDataCampaigns.totalPages}`
        this.currentPage = `${this.metaDataCampaigns.currentPage}`
        this.pagesSelected = `${this.metaDataCampaigns.limitValue}`
        this.total = this.metaDataCampaigns.totalCount
      }
    }
  },

  mounted () {
    this.updateMetaDataTable()
    this.getCampaigns({page: Number(this.currentPage), limit: Number(this.limit)})

    if (!this.loading) {
      if (this.listCampaigns.length === 0) {
        this.empty = true
      } else {
        this.empty = false
      }
    }

    this.$store.commit('campaign/SET_DATA_CAMAPAIGN', {})
  },

  updated() {
    this.updateMetaDataTable()
    this.disabledPrevButton()
    this.disabledNextButton()
  }
}
